import axios from "axios";
import auth from "@/client/guards/auth";
// Create single axios instance
var instance = axios.create();
instance.defaults.headers.common['Accept'] = 'application/json';
instance.defaults.headers.common['Content-Type'] = 'application/json';
instance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
instance.defaults.withCredentials = true;
instance.interceptors.response.use(function (r) { return r; }, auth);
export default instance;
